export default __webpack_public_path__ + "static/media/episode-6.18d39477.jpg";